import { Icon } from 'Components';
import { APP_ROUTES } from 'Pages/App/App.constants';
import { getLeadPath } from 'Pages/App/AppLayout/AppHeader/AppHeader.helpers';
import { PermissionCode } from 'Services/Api/Users/Types';
import { HELP_DESK_LINK, PUBLIC_RESOURES_URLS } from 'app-config';
import { I18N_LANGUAGE_LIST, TITLE_BY_MENU_KEY } from 'i18n/i18n.constants';

export interface NavItemConfig {
	key: string;
	id?: string;
	label: string;
	icon?: React.ReactNode;
	isExternal?: boolean;
	path?: string;
	children?: Omit<NavItemConfig, 'children'>[];
	allowClick?: boolean;
}

export const PEAKPORTAL_KEY = 'PeakPortal';

export const LANGUAGE_DROPDOWN = I18N_LANGUAGE_LIST.map((code) => {
	const title = TITLE_BY_MENU_KEY[code];
	return { key: code, id: code, label: title, path: code };
});

export const mainNavItems: NavItemConfig[] = [
	{
		key: PermissionCode.ViewDashboardOverview,
		id: 'dashboard',
		label: 'sidebar.dashboard',
		icon: <Icon type="dashboardIcon" />,
		path: APP_ROUTES.HOME
	},
	{
		key: 'training',
		id: 'training',
		label: 'Training',
		icon: <Icon type="trainingIcon" />,
		children: [
			{
				key: PermissionCode.ViewDashboardMyResults,
				id: 'my-courses',
				label: 'My Courses',
				icon: <Icon type="coursesIcon" />,
				path: APP_ROUTES.MY_COURSES
			},
			{
				key: PermissionCode.VIEW_TRAINING_ASSIGNMENT_WIZARD,
				id: 'assignments',
				label: 'Assignments',
				icon: <Icon type="assignmentsIcon" />,
				path: APP_ROUTES.ASSIGNMENTS
			},
			{
				key: PermissionCode.ViewDashboardElearning,
				id: 'training-report',
				label: 'sidebar.reports.title',
				icon: <Icon type="reportsIcon" />,
				path: APP_ROUTES.TRAINING_REPORT
			}
		]
	},
	{
		key: 'phishing',
		id: 'phishing',
		label: 'sidebar.phishing.title',
		icon: <Icon type="phishingIcon" />,
		children: [
			{
				key: PermissionCode.ViewPhishingManager,
				id: 'phishing-manager',
				label: 'sidebar.phishing.manager',
				icon: <Icon type="managerIcon" />,
				path: APP_ROUTES.PHISHING_MANAGER
			},
			{
				key: PermissionCode.ViewPhishingTemplateManager,
				id: 'phishing-template-manager',
				label: 'sidebar.phishing.library',
				icon: <Icon type="books" />,
				path: APP_ROUTES.PHISHING_TEMPLATE_MANAGER
			},
			{
				key: PermissionCode.ViewDashboardPhishing,
				id: 'phishing-report',
				label: 'sidebar.reports.title',
				icon: <Icon type="reportsIcon" />,
				path: APP_ROUTES.PHISHING
			}
		]
	},
	{
		key: PermissionCode.ViewDashboardSAQCompliance,
		id: 'saq-compliance',
		label: 'sidebar.reports.saqCompliance',
		icon: <Icon type="saqMenuIcon" />,
		path: APP_ROUTES.SAQ_COMPLAINCE
	},
	{
		key: PermissionCode.ViewDashboardScanning,
		id: 'scanning',
		label: 'sidebar.reports.scanning',
		icon: <Icon type="scanningMenuIcon" />,
		path: APP_ROUTES.SCANNING
	},
	{
		key: 'resources',
		id: 'resources',
		label: 'sidebar.resources.title',
		icon: <Icon type="resourceMenuIcon" />,
		children: [
			{
				key: PermissionCode.VIEW_WHITELISTING,
				id: 'whitelisting',
				label: 'sidebar.resources.whitelisting',
				icon: <Icon type="whitelistingMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.phising,
				allowClick: true
			},
			{
				key: PermissionCode.VIEW_POLICIES,
				id: 'policies',
				label: 'sidebar.resources.policies',
				icon: <Icon type="policiesMenuIcon" />,
				isExternal: true,
				path: PUBLIC_RESOURES_URLS.policytemplates,
				allowClick: true
			}
		]
	},
	{
		key: 'settings',
		id: 'settings',
		label: 'sidebar.settings.title',
		icon: <Icon type="settingsIcon" />,
		children: [
			{
				key: PermissionCode.UserManagerScreenView,
				id: 'users',
				label: 'sidebar.settings.users',
				icon: <Icon type="userMenuIcon" />,
				path: APP_ROUTES.USERS,
				allowClick: true
			},
			{
				key: PermissionCode.ViewGroups,
				id: 'groups',
				label: 'sidebar.settings.groups',
				icon: <Icon type="users" />,
				path: APP_ROUTES.GROUPS_LANDING,
				allowClick: true
			},
			{
				key: PermissionCode.ViewOwnershipGroups,
				id: 'ownership',
				label: 'sidebar.settings.ownership',
				icon: <Icon type="ownerShipMenuIcon" />,
				path: APP_ROUTES.OWNERSHIP_GROUPS_LANDING,
				allowClick: true
			},
			{
				key: PermissionCode.ViewRoles,
				id: 'roles',
				label: 'sidebar.settings.roles',
				icon: <Icon type="roleMenuIcon" />,
				path: APP_ROUTES.ROLES,
				allowClick: true
			},
			{
				key: PermissionCode.ViewMappingTenant,
				id: 'mapping',
				label: 'sidebar.settings.mapping',
				icon: <Icon type="mappingMenuIcon" />,
				path: APP_ROUTES.MAPPING
			},
			{
				key: PermissionCode.VIEW_FEATURE_MANAGER,
				id: 'feature-manager',
				label: 'sidebar.settings.features',
				icon: <Icon type="featureIcon" />,
				path: APP_ROUTES.FEATURE_MANAGER
			},
			{
				key: '', // donot remove it is used to add a HR with the list
				id: 'menu-divider',
				label: '',
				path: ''
			},
			{
				key: PermissionCode.ViewStandardReports,
				id: 'saved-report',
				label: 'sidebar.reports.saved',
				icon: <Icon type="savedMenuIcon" />,
				path: APP_ROUTES.SAVED_REPORTS,
				allowClick: true
			},
			{
				key: PermissionCode.ViewDashboardUserActivity,
				id: 'user-activity',
				label: 'sidebar.reports.userActivity',
				icon: <Icon type="users" />,
				path: APP_ROUTES.USER_ACTIVITY,
				allowClick: true
			},
			{
				key: PermissionCode.ViewStandardReports,
				id: 'export-reports',
				label: 'sidebar.settings.exports',
				icon: <Icon type="libraryMenuIcon" />,
				path: APP_ROUTES.REPORTS,
				allowClick: true
			},
			{
				key: PermissionCode.ViewAuditLog,
				id: 'audit-logs',
				label: 'sidebar.reports.auditLogs',
				icon: <Icon type="auditLogMenuIcon" />,
				path: APP_ROUTES.AUDIT_LOG,
				allowClick: true
			}
		]
	}
];

export const bottomNavItems: NavItemConfig[] = [
	{
		key: 'language',
		id: 'language',
		label: 'English',
		icon: <Icon type="languageIcon" />,
		children: LANGUAGE_DROPDOWN
	},
	{
		key: 'help',
		id: 'help',
		label: 'sidebar.bottom.help',
		icon: <Icon type="helpIcon" />,
		isExternal: true,
		path: HELP_DESK_LINK
	}
];

export const accountItems: NavItemConfig[] = [
	{
		key: 'profile',
		id: 'profile',
		label: 'sidebar.account.settings',
		icon: <Icon type="profileMenuIcon" />,
		path: APP_ROUTES.PROFILE
	},
	{
		key: 'logout',
		id: 'logout',
		label: 'sidebar.account.signOut',
		icon: <Icon type="logoutMenuIcon" />,
		path: APP_ROUTES.LOGOUT
	}
];

const GET_MENU_NAME_BY_SUBMENU: Record<string, string> = {
	'groups-new': APP_ROUTES.GROUPS_LANDING,
	'groups-deleted': APP_ROUTES.GROUPS_LANDING,
	'groups': APP_ROUTES.GROUPS_LANDING,
	'groups-hierarchy': APP_ROUTES.GROUPS_LANDING,
	'tenants': APP_ROUTES.GROUPS_LANDING,
	'ownership-groups-new': APP_ROUTES.OWNERSHIP_GROUPS_LANDING,
	'ownership-groups': APP_ROUTES.OWNERSHIP_GROUPS_LANDING
};

const leadPaths = [
	APP_ROUTES.REPORTS,
	APP_ROUTES.SAVED_REPORTS,
	APP_ROUTES.USER_ACTIVITY,
	APP_ROUTES.PHISHING,
	APP_ROUTES.PHISHING_MANAGER,
	APP_ROUTES.PHISHING_TEMPLATE_MANAGER,
	APP_ROUTES.TRAINING_REPORT
];

export const getRawPath = (pathname: string) => {
	let rawLeadPath = getLeadPath(pathname);

	if (rawLeadPath && ["reports", "phishing-manager", "training"].includes(rawLeadPath)) {
		const matchedPath = leadPaths.find((path) => pathname === path);
		if (matchedPath) rawLeadPath = matchedPath.replace('/', '');
	}

	const leadPath = rawLeadPath ? GET_MENU_NAME_BY_SUBMENU[rawLeadPath] || `/${rawLeadPath}` : '';
	return leadPath;
};

export const PAGE_NOT_ALLOWED_ON_MOBILE = [
	PermissionCode.ViewAuditLog,
	PermissionCode.UserManagerScreenView,
	PermissionCode.ViewGroups,
	PermissionCode.ViewOwnershipGroups,
	PermissionCode.ViewRoles,
	PermissionCode.ViewMappingTenant
]

export const ALWAYS_ENBALED_ROUTES = [
	APP_ROUTES.USER_ACTIVITY,
	APP_ROUTES.REPORTS,
	APP_ROUTES.SAVED_REPORTS,
	APP_ROUTES.AUDIT_LOG,
	APP_ROUTES.USERS,
	APP_ROUTES.GROUPS_LANDING,
	APP_ROUTES.OWNERSHIP_GROUPS_LANDING,
	APP_ROUTES.PROFILE,
	APP_ROUTES.COURSES,
	APP_ROUTES.TRAINING_REPORT
]
